module.exports = __webpack_public_path__ + "img/tooltip_06-vallone-como-29-B.12c494c4.jpg";